import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=12f2345c&scoped=true"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"
import style0 from "./Milestone.vue?vue&type=style&index=0&id=12f2345c&prod&lang=scss&scoped=true"
import style1 from "./Milestone.vue?vue&type=style&index=1&id=12f2345c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f2345c",
  null
  
)

export default component.exports